export enum MediaType {
  APPLICATION_JSON = 'application/json',
  TEXT_CSV = 'text/csv'
}
